// This is a mitigation to avoid tracking script error breaking page load
if (typeof window.sessionStorage === 'object' && window.sessionStorage.getItem('pi_ucvm') === '1') {
  window.sessionStorage.removeItem('pi_ucvm');
}
